var _jsxFileName = "/home/runner/work/frontend-shared/frontend-shared/src/components/input/ButtonBase.tsx";
import classNames from 'classnames';
import { downcastRef } from '../../util/typing';

/**
 * Common props used for Button components.
 */

/**
 * HTML attributes accepted by button components. This eliminates conflicting
 * `icon` and `size` attributes.
 */
import { jsxDEV as _jsxDEV } from "preact/jsx-dev-runtime";
/**
 * Base component for Button components. Applies common attributes.
 *
 * @deprecated Use `Button` or `IconButton` with `unstyled` set instead
 */
const ButtonBase = function ButtonBase({
  elementRef,
  children,
  classes,
  unstyled = false,
  expanded,
  pressed,
  title,
  role,
  ...htmlAttributes
}) {
  const ariaProps = {
    'aria-label': title
  };

  // aria-pressed and aria-expanded are not allowed for buttons with
  // an aria role of `tab`. Instead, the aria-selected attribute is expected.
  if (role === 'tab') {
    ariaProps['aria-selected'] = pressed;
  } else {
    ariaProps['aria-pressed'] = pressed;
    ariaProps['aria-expanded'] = expanded;
  }
  return _jsxDEV("button", {
    role: role !== null && role !== void 0 ? role : 'button',
    ...ariaProps,
    "data-base-component": "ButtonBase"
    /* data-component will be overwritten unless this component is used directly */,
    "data-component": "ButtonBase"
    // Setting a default `type` can prevent undesired form submissions in
    // certain cases
    ,
    type: "button",
    ...htmlAttributes,
    className: classNames({
      'focus-visible-ring': !unstyled,
      'transition-colors': !unstyled,
      // Set layout for button content
      'whitespace-nowrap flex items-center': !unstyled
    }, classes),
    title: title,
    ref: downcastRef(elementRef),
    children: children
  }, void 0, false, {
    fileName: _jsxFileName,
    lineNumber: 81,
    columnNumber: 5
  }, this);
};
export default ButtonBase;
//# sourceMappingURL=ButtonBase.js.map